import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import pushEvent, { SCROLL_TOP_BTN_CLICK } from 'pushEvent';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';

import { scrollPossibleArea, scrollToTop } from './helpers';
import UpIcon from './assets/btn_up.svg';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Scroll to top button
 */
class ScrollTopButton extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      showScrollButton: false,
    };
    this.yOffset = 0;

    /**
     * Save last scroll direction; in case update was called,
     * and there was no scrolling, we use previous value,
     * use it in mobile specific show condition, when mobile button will be approved
     */
    // this.isTopScrolling = false;
  }

  componentDidMount() {
    this.handleScroll();
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const { showScrollButton } = this.state;
    // const scrollDelta = window.pageYOffset - this.yOffset;
    this.yOffset = window.pageYOffset;
    /** if we got a real scroll, determine new direction, otherwise, just keep previous */
    // this.isTopScrolling = scrollDelta !== 0 ? scrollDelta < 0 : this.isTopScrolling;

    /** show button after 2 display heights have been scrolled */
    if (this.yOffset >= scrollPossibleArea() && !showScrollButton) {
      this.setState({ showScrollButton: true });
    } else if (this.yOffset < scrollPossibleArea() && showScrollButton) {
      this.setState({ showScrollButton: false });
    }
  };

  render() {
    const { className, isMobile } = this.props;
    const { showScrollButton } = this.state;
    return (
      !isMobile && (
        <div
          className={cx(
            'scrollTopButton',
            showScrollButton && 'show',
            isMobile && 'mobile',
            className,
          )}
          role="button"
          tabIndex={0}
          onClick={() => {
            scrollToTop();
            pushEvent(SCROLL_TOP_BTN_CLICK);
          }}
        >
          <UpIcon className={cx('icon', isMobile && 'mobile')} />
        </div>
      )
    );
  }
}

ScrollTopButton.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isMobile: isScreenBelow800(state),
});

export default connect(mapStateToProps)(ScrollTopButton);
